import { IDeviceFormat } from '../models/IShareOfBusiness'

type TBrand = keyof Pick<IDeviceFormat, 'topVendorBrand1' | 'topVendorBrand2' | 'topVendorBrand3'>

export type TTopVendorBrandItem = {
  brand: TBrand
}

export const topVendorBrandA3: TTopVendorBrandItem[] = [
  {
    brand: 'topVendorBrand1',
  },
  {
    brand: 'topVendorBrand2',
  },
  {
    brand: 'topVendorBrand3',
  },
]
export const topVendorBrandA4: TTopVendorBrandItem[] = [
  {
    brand: 'topVendorBrand1',
  },
  {
    brand: 'topVendorBrand2',
  },
  {
    brand: 'topVendorBrand3',
  },
]

const calculateTopVendorBrand = (deviceFormat: IDeviceFormat, brands: TTopVendorBrandItem[]) => {
  const copy = structuredClone(deviceFormat)
  const sortedBrands = brands.sort((a, b) => copy[b.brand].spend - copy[a.brand].spend)

  const hpBrandItem = sortedBrands.find((it) => copy[it.brand].name === 'HP')
  const calculatedHPBrand = copy.hpBrand / (copy.allBrands || 1)
  if (hpBrandItem) {
    copy[hpBrandItem.brand].spend = calculatedHPBrand
  } else {
    const newHPBrand = sortedBrands.find((it) => copy[it.brand].spend <= calculatedHPBrand)
    if (newHPBrand) {
      copy[newHPBrand.brand].name = 'HP'
      copy[newHPBrand.brand].spend = calculatedHPBrand
    }
  }

  const otherBrandSpend =
    1 - (copy.topVendorBrand1.spend + copy.topVendorBrand2.spend + copy.topVendorBrand3.spend)

  if (otherBrandSpend < 0) {
    const [firstNonHPBrand] = sortedBrands.filter((it) => copy[it.brand].name !== 'HP')
    copy[firstNonHPBrand.brand].spend += otherBrandSpend
  }

  brands.forEach((it, index) => {
    const sortedBrand = sortedBrands[index]
    copy[it.brand].name = copy[sortedBrand.brand].name
    copy[it.brand].spend = copy[sortedBrand.brand].spend
  })

  copy.otherBrandSpend = otherBrandSpend <= 0 ? 0 : otherBrandSpend

  return copy
}

export const calculateTopVendorsA3 = (deviceFormat: IDeviceFormat) => {
  return calculateTopVendorBrand(deviceFormat, topVendorBrandA3)
}

export const calculateTopVendorsA4 = (deviceFormat: IDeviceFormat) => {
  return calculateTopVendorBrand(deviceFormat, topVendorBrandA4)
}
